import { Caption } from '@casavo/base-ui'
import { motion } from 'framer-motion'
import React from 'react'

import { useDevice } from '@/context/Device'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'

const linkAnimation = {
  animate: {
    transition: {
      delay: 4.5,
      duration: 0.5,
    },
    x: [0, 10, 0],
  },
}

const svgAnimation = {
  hover: {
    transition: {
      duration: 0.5,
      type: 'tween',
    },
    x: [0, 3, 0],
  },
}

const LinkArrow: React.FC<{
  color?: string
  fontSize?: number
  href?: string
  iconSize?: number
  inView?: boolean
  label: string
  onClick?: VoidFunction
  spacing?: number
}> = ({
  color = 'currentColor',
  fontSize = 16,
  href,
  iconSize = 16,
  inView,
  label,
  onClick,
  spacing = 16,
  ...linkProps
}) => {
  const device = useDevice()
  const linkTag = motion.a
  const buttonTag = motion.button
  const CustomTag = href ? linkTag : buttonTag

  return (
    <CustomTag
      animate={inView && 'animate'}
      className={sprinkles({ alignItems: 'center', cursor: 'pointer', display: 'flex', gap: 's', margin: '0 auto' })}
      href={href}
      initial="initial"
      style={{
        color,
        fontSize,
      }}
      variants={linkAnimation}
      whileHover="hover"
      onClick={onClick}
      {...linkProps}
    >
      <Caption strong>{label}</Caption>
      <motion.svg
        fill="none"
        height={iconSize}
        variants={svgAnimation}
        viewBox="0 0 16 16"
        width={iconSize}
        xmlns="http://www.w3.org/2000/svg"
      >
        {device === 'desktop' ? (
          <path
            clipRule="evenodd"
            d="M8 0L6.59 1.41L12.17 7H0L0 9H12.17L6.58 14.58L8 16L16 8L8 0Z"
            fill={color}
            fillRule="evenodd"
          />
        ) : (
          <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
            <path
              clipRule="evenodd"
              d="M5.70718 0.292892L13.4143 8L5.70718 15.7071L4.29297 14.2929L10.5851 8L4.29297 1.70711L5.70718 0.292892Z"
              fill={color}
              fillRule="evenodd"
            />
          </svg>
        )}
      </motion.svg>
    </CustomTag>
  )
}

export default LinkArrow
